import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Cookie, X } from 'lucide-react';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      // Small delay before showing the banner
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    localStorage.setItem('cookiesAcceptedDate', new Date().toISOString());
    setShowBanner(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem('cookiesAccepted', 'necessary');
    localStorage.setItem('cookiesAcceptedDate', new Date().toISOString());
    setShowBanner(false);
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
        >
          <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-2xl border border-slate-200 p-6">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center">
                  <Cookie className="w-6 h-6 text-slate-700" />
                </div>
              </div>
              
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-slate-900 mb-2">
                  Informativa sui Cookie
                </h3>
                <p className="text-slate-600 text-sm mb-4">
                  Utilizziamo i cookie per migliorare la tua esperienza sul nostro sito. 
                  I cookie tecnici sono necessari per il funzionamento del sito, mentre i cookie 
                  di analisi ci aiutano a capire come utilizzi il servizio. Puoi accettare tutti 
                  i cookie o solo quelli necessari.{' '}
                  <a href="/privacy" className="text-slate-900 underline hover:no-underline">
                    Leggi la nostra Privacy Policy
                  </a>
                </p>
                
                <div className="flex flex-col sm:flex-row gap-3">
                  <Button
                    onClick={acceptCookies}
                    className="bg-slate-900 hover:bg-slate-800 text-white px-6"
                    data-testid="accept-all-cookies"
                  >
                    Accetta Tutti
                  </Button>
                  <Button
                    onClick={acceptNecessary}
                    variant="outline"
                    className="border-slate-300 text-slate-700 hover:bg-slate-100 px-6"
                    data-testid="accept-necessary-cookies"
                  >
                    Solo Necessari
                  </Button>
                  <a
                    href="/gestione-privacy"
                    className="inline-flex items-center justify-center text-sm text-slate-600 hover:text-slate-900 underline"
                  >
                    Gestisci Preferenze
                  </a>
                </div>
              </div>
              
              <button
                onClick={acceptNecessary}
                className="flex-shrink-0 text-slate-400 hover:text-slate-600 transition-colors"
                aria-label="Chiudi"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
